import React from "react";
import ReactDOM from "react-dom";

import { CommunityType } from "@js/invenio_communities";
import CommunitiesCardGroup from "./CommunitiesCardGroup";

const newCommunitiesContainer = document.getElementById("new-communities");

// Shows communities
if (newCommunitiesContainer) {
    const communityTypeNewCommunities = new CommunityType(
        newCommunitiesContainer.dataset.communityType
    );
    const searchQuery = newCommunitiesContainer.dataset.searchquery;
    const sortOption = newCommunitiesContainer.dataset.sortoption??"bestmatch";
    const communityTypeList = newCommunitiesContainer.dataset.communityType === "" ?
        (new CommunityType()).getListSingular():[communityTypeNewCommunities.communityType];

    ReactDOM.render(
        <>
            {communityTypeList?.map((communityType) => {
                return <CommunitiesCardGroup
                    fetchDataUrl={
                        "/api/" +
                        (new CommunityType(communityType)).getApi() +
                        `?q=${searchQuery}&sort=${sortOption}&page=1&size=3`
                    }
                    defaultLogo="/static/images/square-placeholder.png"
                    emptyMessage={
                        "There is no " +
                        communityType +
                        " for your search "
                    }
                    itemsPerRow={3}
                    communityType={communityType}
                    searchquery={searchQuery}
                />
            })}

        </>,

        newCommunitiesContainer,
    );
}
